import { FC, useContext, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/store.hooks';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useParams, useNavigate } from 'react-router-dom';
import { Bars } from 'react-loader-spinner';
import ErrorMiddlewareTransactionDetails from './Errormiddleware';
import ErrorMiddlewareUserDetails from './Errormiddleware';
import { getOrder } from '../reducer/orderDetailsSlice';
import store from '../../../store/store';
import { addBreadcrumb } from '../../../components/Breadcrumbs/reducer/breadcrumbSlice';

interface UserDetailsInterface {
  token: any;
  merchantUserID?: any;
}

const InitMiddlewareOrderDetails: FC<UserDetailsInterface> = (props) => {
  const oneOrderData = useSelector((state: any) => state.rootReducer.orderDetail.oneOrderData);
  const userStatusEditDetails = useSelector((state: any) => state.rootReducer.orderDetail.userStatusEditDetails);
  const userDataLoading = useSelector((state: any) => state.rootReducer.orderDetail?.isLoading.orderData);
  const { userToken } = useSelector((state: any) => state.rootReducer.auth);

  const dispatch = useAppDispatch();
  const location = useLocation();
  const usePathname = () => {
    return location.pathname;
  };
  const pathMerchantUserID = usePathname().split('/').slice(-1)[0];

  let { orderId } = useParams();

  useEffect(() => {
    dispatch(getOrder({
      orderId: orderId
    }));
  }, [userStatusEditDetails]);


  useEffect(() => {
    const data: any = [
      {
        label: 'Orders',
        link: `/users`,
      },
      {
        label: 'Order Details',
        link: `/orders/${orderId}`,
      },
    ];
    // const data: any = {};
    store.dispatch(addBreadcrumb(data));
  }, [oneOrderData]);

  if (userDataLoading) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <Bars height="80" width="80" color="#2460a2" ariaLabel="bars-loading" wrapperStyle={{}} wrapperClass="" visible={true} />
      </div>
    );
  }

  return (
    <>
      <ErrorMiddlewareUserDetails {...props} />
    </>
  );
};

export default InitMiddlewareOrderDetails;
